// extracted by mini-css-extract-plugin
export default {"snackbar":"Toast_snackbar__rvnXJ","smallScreen":"Toast_smallScreen__-lcDb"};